export default "__VITE_ASSET__D2eV14IX__"